export default __webpack_public_path__ + "static/media/Telefone.57825c21.svg";